<template>
  <el-dropdown size="small" class="d2-mr">
    <span class="btn-text">{{ info.name ? `${$t("Hello")} ${info.name}` : "Not logged in" }}</span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="handleModifyPassword">
        <d2-icon name="edit" class="d2-mr-5" />
        {{ $t("modifyPassword") }}
      </el-dropdown-item>
      <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off" class="d2-mr-5" />
        Logout
      </el-dropdown-item>
    </el-dropdown-menu>
    <ModifyPassword ref="modifyPassword" :type="1" @success="handleModifySuccess"></ModifyPassword>
  </el-dropdown>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ModifyPassword from "@/components/modifyPassword";
export default {
  components: { ModifyPassword },
  computed: {
    ...mapState("d2admin/user", ["info"]),
  },
  methods: {
    ...mapActions("d2admin/account", ["logout"]),
    /**
     * @description 登出
     */
    logOff() {
      this.logout({
        confirm: true,
      });
    },
    handleModifyPassword() {
      this.$refs.modifyPassword.show({});
    },
    handleModifySuccess() {
      this.logout({
        confirm: false,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-text {
  padding: 1rem 2rem !important;
  border-left: 2px solid #ddd;
  border-radius: 0px !important;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
